export default {
  heading: '',
  collection: [
    {
      copy: '“Tribal are an absolute pleasure. And working out of their office was crucial to the success of the project”',
      image: {
        alt: '',
        filename: '//a.storyblok.com/f/46530/100x100/7add25ec01/__icon-o2.svg',
      },
      component: 'm-client',
    },
    {
      copy: '',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/a98c3d0c05/__icon-skoda.svg',
      },
      component: 'm-client',
    },
    {
      copy: '',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/020cdd8484/__icon-adidas.svg',
      },
      component: 'm-client',
    },
    {
      copy: '',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/8cc49cd5fa/__icon-avios.svg',
      },
      component: 'm-client',
    },
    {
      copy: '',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/ca9411de80/__icon-carte-dor.svg',
      },
      component: 'm-client',
    },
    {
      copy: '"Tribal created a brand personality for us that weaves across all our customer touchpoints."',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/784ca0fa43/__icon-wren.svg',
      },
      component: 'm-client',
    },
    {
      copy: '',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/dd05f0b5dc/__icon-disney.svg',
      },
      component: 'm-client',
    },
    {
      copy: '',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/a5f98b4236/__icon-unilever.svg',
      },
      component: 'm-client',
    },
    {
      copy: '',
      image: {
        alt: '',
        filename: '//a.storyblok.com/f/46530/100x100/21b73584e1/__icon_j-j.svg',
      },
      component: 'm-client',
    },
    {
      copy: '',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/b6eb53fc8d/__icon-walls.svg',
      },
      component: 'm-client',
    },
    {
      copy: '',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/3b5a916390/__icon-babcock.svg',
      },
      component: 'm-client',
    },
    {
      copy: '',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/25bf3fa317/__icon-captain-morgans.svg',
      },
      component: 'm-client',
    },
    {
      copy: '“Tribal have been part of our team for over 20 years. Their work is second to none."',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/bf93ff72ce/__icon-volkswagen.svg',
      },
      component: 'm-client',
    },
    {
      copy: '',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/792fcb47f6/__icon-falabella.svg',
      },
      component: 'm-client',
    },
    {
      copy: '',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/2331dfad50/__icon-guinness-storehouse.svg',
      },
      component: 'm-client',
    },
    {
      copy: '',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/51ed0e8225/__icon-morrisons.svg',
      },
      component: 'm-client',
    },
    {
      copy: '',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/eabe8b68eb/__icon-volkswagen-cv.svg',
      },
      component: 'm-client',
    },
    {
      copy: '',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/36dff597f7/__icon-biogen.svg',
      },
      component: 'm-client',
    },
    {
      copy: '',
      image: {
        alt: '',
        filename:
          '//a.storyblok.com/f/46530/100x100/4e0e9a5b37/__icon-seat.svg',
      },
      component: 'm-client',
    },
  ],
  component: 'o-awards',
}
